import {FileState} from "./file.state";

export const listFiles = (state: any) => state.files;

export const uploadQueue = (state: FileState) => state.file.newUploadQueue;
